module.exports = __webpack_public_path__ + "img/fences, gates.94e7ba96.jpg";